import { sortCosts } from 'src/helpers'
import { ItemizedCostFragment } from 'src/graphql'

const getCosts = (cost: ItemizedCostFragment, isFree = false) => {
  if (!cost) {
    return []
  }
  return sortCosts(
    cost.entries
      .filter(
        entry =>
          entry.label.indexOf('Card Upgrades') > -1 ||
          entry.currency.indexOf('CARDTOKEN') > -1 ||
          entry.label.indexOf('Volume Discount') > -1 ||
          entry.label.indexOf('Shipping') > -1 ||
          entry.label.indexOf('Processing') > -1 ||
          entry.label.indexOf('Gift Handling Fees') > -1,
      )
      .map(entry => ({
        label:
          entry.label === 'Volume Discount' ? `*${entry.label}` : entry.label,
        amount: entry.currency === 'CARDTOKEN' ? entry.amount : entry.asString,
      })),
  )
}

export default getCosts
